/** ***********************************************************************
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ************************************************************************* */

import React from 'react';
import { observer } from 'mobx-react';
import SingleAppEmphasisCard from './appTile';
import { CatalogAnalytics } from '../../../analytics';
import { ANALYTICS } from '../../../utils/enums';
import { filterAppsForAppSection, getContentExt } from '../../../utils/commonUtil';
import './index.scss';

export default observer(({
    appConfig, appsSkeletonModel, allAppsModel, routingProps,
    appSection, subSection = {}, sectionHeader = {}, layoutId,
}) => {
    const filteredTiles = filterAppsForAppSection(
        allAppsModel,
        appSection,
        subSection,
        sectionHeader
    );

    appsSkeletonModel.setSelectedSubSection(subSection.id);

    if (!filteredTiles.length) {
        return [];
    }

    if (CatalogAnalytics.sendAnalyticsBool) {
        filteredTiles.forEach((app) => {
            let headerBasedAppData = {};
            if (appSection
                && appSection.sectionAppsData
                && appSection.sectionAppsData[app.sapcode]) {
                headerBasedAppData = appSection.sectionAppsData[app.sapcode];
            }
            const { mediaList = [] } = headerBasedAppData;
            const contentExt = getContentExt(mediaList);
            CatalogAnalytics.appsAnalyticsArray.push(CatalogAnalytics.sendAnalytics(
                appConfig, appsSkeletonModel, ANALYTICS.EVENTS.RENDER_APP,
                {
                    app,
                    appSection,
                    viewType: ANALYTICS.VIEW_TYPE[layoutId],
                    contentSize: '100',
                    contentExt,
                }
            ));
        });
    }

    return (
        <div
            role="region"
            aria-label={sectionHeader.ariaLabel || appSection.ariaLabel}
            className="singleAppEmphasisView-app-tiles-header-section"
            key={`${appSection.id}${sectionHeader.id}`}>
            {sectionHeader.localizedText && (
                <div className="singleAppEmphasisView-app-tiles-header"> {sectionHeader.localizedText} </div>
            )}
            <div className={`singleAppEmphasisView-app-tiles-wrapper ${layoutId}`}>
                {
                    filteredTiles.map((app, index) => (<SingleAppEmphasisCard className={`singleAppEmphasisView-app-tile ${index % 2 ? 'odd-numbered' : 'even-numbered'}`} key={`${app.sapcode}-${app.codexVersion}`} app={app} appSectionFilter={appSection.id} subSectionFilter={subSection.id} sectionHeader={sectionHeader.id} {...routingProps} appSection={appSection} layoutId={layoutId} appConfig={appConfig} />))
                }
            </div>
        </div>
    );
});
